import React from 'react';

import { ToggleButtonGroup, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  donationCard: {
    backgroundColor: getDesignToken('background-card'),
    borderRadius: spacing.$1,
    flexDirection: 'column',
    padding: spacing.$4,
  },
});

export const StyledDonationCard = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.donationCard, style] });

export const StyledDonationTitle = withTypography({
  variant: 'headerThree',
  mb: '$0',
  focusable: true,
});

export const StyledDonationSubTitle = withTypography({
  variant: 'copyTwo',
  fontSize: 'sm',
  focusable: true,
});

export const StyledToggleButtonGroup = makeUclComponent(ToggleButtonGroup).withConfig({
  marginTop: '$4',
});
